export const companyDetail113 = {
  communicationChannels: [],
  employeesData: {
    minNumber: 0,
    maxNumber: 0,
  },
  financialData: {
    shareCapitalAmount: 18812374,
    currencyCode: 'EUR',
  },
  groupLinks: [
    {
      groupId: '26514',
      isGroupHead: false,
    },
  ],
  companyId: '113',
  address: {
    streetNumber: '27',
    streetName: 'RUE DE LA CHAUSSEE D ANTIN',
    postCodes: [
      {
        postCodeTypeCode: 'POSTCODE',
        postCodeValue: '75009',
      },
    ],
    town: 'PARIS 9',
    subdivisionCode: '75',
    countryCode: 'FR',
  },
  legalData: {
    companyName: 'GL IMMO MARAIS',
    secondaryNames: [
      {
        nameTypeCode: 'NAMETYPE04',
        alternativeName: 'BHV',
      },
    ],
    effectiveDate: '2003-07-28',
    creationDate: '1954-01-01',
    businessStartDate: '2016-12-31',
    companyStatusCode: 'A',
    companyTypeCode: 'C',
    legalFormCode: 'SAS',
    tradeSectors: [
      {
        nomenclatureCode: 'NAF',
        isMainTradeSector: true,
      },
      {
        nomenclatureCode: 'NAF',
        isMainTradeSector: false,
      },
      {
        nomenclatureCode: 'NAF',
        isMainTradeSector: false,
      },
      {
        nomenclatureCode: 'NAF',
        isMainTradeSector: false,
      },
      {
        nomenclatureCode: 'NAF',
        isMainTradeSector: false,
      },
      {
        nomenclatureCode: 'NAF',
        isMainTradeSector: false,
      },
      {
        nomenclatureCode: 'NAF',
        isMainTradeSector: false,
      },
      {
        nomenclatureCode: 'NAF',
        isMainTradeSector: false,
      },
      {
        nomenclatureCode: 'NAF',
        isMainTradeSector: false,
      },
      {
        nomenclatureCode: 'NAF',
        isMainTradeSector: false,
      },
    ],
    languageCode: 'FR',
    isPublicCompany: false,
    isDataProtected: false,
  },
  companyIdentifiers: [
    {
      priorityNumber: 9,
      isNationalIdentifier: false,
      idTypeCode: 'HRM',
      idValue: '1180334815',
    },
    {
      priorityNumber: 9,
      isNationalIdentifier: false,
      idTypeCode: 'DUN',
      idValue: '275137701',
    },
    {
      priorityNumber: 1,
      isNationalIdentifier: true,
      idTypeCode: 'SIREN',
      idValue: '542052865',
    },
    {
      priorityNumber: 9,
      isNationalIdentifier: false,
      idTypeCode: 'SIRET',
      idValue: '54205286500632',
    },
  ],
};

export const companyDetail114 = {
  localizedData: {
    address: {
      postCodes: [],
    },
    legalData: {
      secondaryNames: [],
    },
    communicationChannels: [],
  },
  communicationChannels: [],
  employeesData: {},
  financialData: {},
  groupLinks: [],
  companyId: '114',
  address: {
    streetName: 'POPERINGESTRAAT 34',
    postCodes: [
      {
        postCodeTypeCode: 'POSTCODE',
        postCodeValue: '8953',
      },
    ],
    town: 'HEUVELLAND (WIJTSCHATE)',
    countryCode: 'BE',
  },
  legalData: {
    companyName: 'BOUDEIN ANDRE',
    secondaryNames: [],
    companyStatusCode: 'C',
    companyStatusReasonCode: 'CESEC',
    companyTypeCode: 'S',
    legalFormCode: 'COM',
    tradeSectors: [
      {
        nomenclatureCode: 'NACEB',
        tradeSectorCode: '16240',
        isMainTradeSector: true,
      },
    ],
    languageCode: 'DU',
    isPublicCompany: false,
    isDataProtected: true,
  },
  companyIdentifiers: [
    {
      priorityNumber: 1,
      isNationalIdentifier: true,
      idTypeCode: 'TVABE',
      idValue: 'BE0522648569',
    },
    {
      priorityNumber: 9,
      isNationalIdentifier: false,
      idTypeCode: 'DUN',
      idValue: '284334182',
    },
  ],
};
